// The full Contact Function Code list (DE 366) — shared by every PER01
// element across transaction sets. Transcribed from
// reference/session/00-envelope-and-common-qualifiers-txt.md.

import type {CodeListEntry} from './types';

export const CONTACT_FUNCTION_CODES: CodeListEntry[] = [
  {code: 'AP', label: 'Accounts Payable Department'},
  {code: 'AR', label: 'Accounts Receivable Department'},
  {code: 'BD', label: 'Buyer Name or Department'},
  {code: 'CN', label: 'General Contact'},
  {code: 'CR', label: 'Customer Relations'},
  {code: 'DC', label: 'Delivery Contact'},
  {code: 'EA', label: 'EDI Coordinator'},
  {code: 'IC', label: 'Information Contact'},
  {code: 'OC', label: 'Order Contact'},
  {code: 'OD', label: 'Order Department'},
  {code: 'RE', label: 'Receiving Contact'},
  {code: 'SR', label: 'Sales Representative or Department'},
  {code: 'SU', label: 'Supplier Contact'},
  {code: 'ZZ', label: 'Mutually Defined'},
];
